import React from 'react';
import { Info } from 'lucide-react';

const DisclaimerFooter: React.FC = () => (
  <div className="mt-2 pt-2 border-t border-slate-700/50 flex items-start gap-1.5">
    <Info size={12} className="text-slate-500 mt-0.5 shrink-0" />
    <p className="text-xs text-slate-500 italic">
      This is not financial advice. my investments is not a licensed financial
      services provider under the FSCA. All analysis and recommendations are for
      educational and informational purposes only. Always consult a licensed financial
      advisor before making investment decisions.
    </p>
  </div>
);

export default DisclaimerFooter;
